import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUmbrellaRain = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		d: "M11.5 18.872C12.091 16.509 16.22 16.509 16.811 18.872C16.829 16.491 21.254 16.509 21.239 18.872C21.5 13.072 17.284 8.25 11.5 8.25C5.716 8.25 1.5 13.072 1.761 18.872C1.746 16.509 6.171 16.491 6.189 18.872C6.78 16.509 10.909 16.509 11.5 18.872Z",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinejoin: "round",
		fill: "none"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.498 8.25V6.75",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.5 23.2499L11.498 18.8719",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22 0.75L19.75 3.75",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17.5 0.75L15.25 3.75",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13 0.75L10.75 3.75",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4 0.75L1.75 3.75",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.5 0.75L6.25 3.75",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}));
});
export default SvgUmbrellaRain;
